<template>
  <span>
    <v-icon :small="smallIcon" @click="refresh">refresh</v-icon>
    <v-icon class="ml-1" :small="smallIcon" v-if="isLoggedIn" @click.stop="logoutClick" >
      {{getIcon('logout')}}
    </v-icon>
    <v-icon class="ml-1" :small="smallIcon" v-if="!isLoggedIn" @click.stop="nav('login')">
      {{getIcon('login')}}
    </v-icon>
    <v-avatar class="ml-1" v-if="isLoggedIn" @click.stop="nav('profile')" :size="iconSize">
      <img v-if="avatar" :src="avatar" :alt="displayName">
      <v-icon v-else @click="nav('profile')" small>person</v-icon>
    </v-avatar>
  </span>
</template>
<script>
import { settings, getIcon } from '@/js/store'
import { clearAllStores } from '@/js/apollo'
export default {
  name: 'app-login-av',
  props: {
    auth: {
      type: Object
    }
  },
  computed: {
    iconSize () {
      return this.smallIcon ? settings.dimensions.blobIconSm : settings.dimensions.blobIconNormal
    },
    smallIcon () {
      return this.$vuetify.breakpoint.smAndDown
    },
    avatar () {
      const pa = this.auth
      return (pa && pa.photoUrl) || ''
    },
    displayName () {
      const pa = this.auth
      return (pa && (pa.displayName || pa.email)) || ''
    },
    isLoggedIn () {
      const pa = this.auth
      return pa && pa.uid
    },
    userID () {
      return this.auth && this.auth.userID
    }
  },
  methods: {
    getIcon (type) {
      return getIcon(type)
    },
    logoutClick () {
      this.$auth.logout()
    },
    nav (name) {
      this.$router.push({
        name
      })
    },
    refresh () {
      clearAllStores()
    }
  }
}
</script>
